var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cStyle", class: _vm.theme },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _c(
        "div",
        { staticClass: "cards" },
        _vm._l(_vm.styleData, function (item, index) {
          return _c("div", { key: index, staticClass: "card" }, [
            _c("img", { attrs: { src: item.img } }),
            _c("div", { staticClass: "content" }, [
              item.content ? _c("div", { staticClass: "line" }) : _vm._e(),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(item.content)),
              ]),
            ]),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }